import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

import store from "../store";

let WebsiteSettings = () => import("../views/WebsiteSettings");

let Product = () => import("../views/Product");
let ProductDetail = () => import("../views/ProductDetail");

let ProductRequest = () => import("../views/ProductRequest");
let ProductRequestDetail = () => import("../views/ProductRequestDetail");

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "home",
        component: Home,
    },
    {
        path: "/websites/:site_id",
        name: "website-settings",
        component: WebsiteSettings,
    },
    {
        path: "/websites/:site_id/products",
        name: "website-products",
        component: Product,
    },
    {
        path: "/websites/:site_id/products/:product_id",
        name: "website-products-detail",
        component: ProductDetail,
    },
    {
        path: "/websites/:site_id/products/new",
        name: "website-products-new",
        component: ProductDetail,
    },

    {
        path: "/websites/:site_id/product-requests",
        name: "website-product-requests",
        component: ProductRequest,
    },
    {
        path: "/websites/:site_id/product-requests/:product_request_id",
        name: "website-product-requests-detail",
        component: ProductRequestDetail,
    },
    {
        path: "/websites/:site_id/product-requests/new",
        name: "website-product-requests-new",
        component: ProductRequestDetail,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

// Intercept router to check if a valid token is needed to access the page
router.beforeEach(async (to, from, next) => {
    try {
        await store.dispatch("auth/checkInit");

        // all routes needs login
        // if (to.matched.some((record) => record.meta.auth)) {
        if (!store.getters["auth/authenticated"]) {
            /*next({
                path: "/login",
                query: { redirect: to.fullPath }
            });*/
            Vue.nextTick(async () => {
                // console.log("login");
                // new Promise(function(resolve, reject) {
                //   EventBus.$emit("show-login-modal", [resolve, reject]);
                // }).then(
                //   (res) => {
                //     next();
                //     return res;
                //   },
                //   (err) => {
                //     if (!from || !from.name) {
                //       next("/");
                //     } else {
                //       // console.log(from);
                //       next(false);
                //     }
                //     return err;
                //   }
                // );

                try {
                    await new Promise((resolve, reject) => {
                        console.log(resolve, reject);
                        store.dispatch("auth/showLoginModal", {
                            show: true,
                            resolve,
                            reject,
                        });
                    });
                    console.log("resolve");
                    next();
                } catch (e) {
                    console.log("reject");
                    if (!form || !form.name) {
                        next("/");
                    } else {
                        next(false);
                    }
                }
            });
        } else {
            next();
        }
        // } else {
        //   next();
        // }
    } catch (e) {
        next(false);
    }
});

// set current website id if needed
router.beforeEach((to, from, next) => {
    console.log(to);
    if (to.params.site_id || to.path == "/") {
        store.commit(
            "setCurrentWebsite",
            to.params.site_id ? parseInt(to.params.site_id) : null
        );
        next();
    } else if (to.path != "/") {
        next("/");
    }
});

export default router;
